// A person's pay-rate history — staff_pay_rates (2026-10-28).
//
// The history is the record of what someone is paid from which date; the
// profile's pay_rate is the rate in force today, kept in step by the database
// (a dated row takes over the profile the day it takes effect, and a rate
// edited on the profile is written here from that day). Payroll pays each
// visit at the rate in force on its date: lib/payroll/payrollLines.js rateOn.

import { must } from './billing/must.js';

export const PAY_TYPES = [
  ['hourly', 'Hourly'], ['per_visit', 'Per visit'], ['weekly', 'Weekly'],
  ['bi_weekly', 'Bi-weekly'], ['monthly', 'Monthly'], ['annually', 'Annual'],
];

export const RATE_SOURCE_LABEL = {
  profile: 'Profile',
  payroll_runs: 'From payroll runs',
  agency_standard: 'Agency standard',
  axiscare: 'AxisCare',
};

export const listPayRates = async (sb, staffId) =>
  (await must(sb.from('staff_pay_rates').select('*').eq('staff_id', staffId).order('effective_from', { ascending: false }), 'read the pay-rate history')) || [];

/** A rate from a date. A second change on the same date replaces the first. */
export const addPayRate = async (sb, { staffId, payType, payRate, effectiveFrom, note, createdBy }) => {
  const rate = Number(payRate);
  if (!staffId || !effectiveFrom || !(rate >= 0) || payRate === '' || payRate == null) throw new Error('Enter a rate and the date it starts.');
  return must(sb.from('staff_pay_rates').upsert({
    staff_id: staffId, pay_type: payType || 'hourly', pay_rate: rate,
    effective_from: effectiveFrom, note: note || null, source: 'profile', created_by: createdBy || null,
  }, { onConflict: 'staff_id,effective_from' }), 'save the rate');
};

export const deletePayRate = (sb, id) =>
  must(sb.from('staff_pay_rates').delete().eq('id', id), 'remove the rate');
